/**
 * Appends (or replaces) a cache-busting `v` query parameter on an asset URL.
 *
 * When a brand moment is replaced by a file with the SAME name, the backend
 * stores it under the same S3 key, so the resulting URL is byte-identical to
 * the previous one and the browser/CDN serves the stale cached object.
 * Stamping a fresh version token produces a unique URL per upload, forcing a
 * fresh fetch. The versioned URL is persisted, so the fix also survives
 * navigating away and back. Empty or invalid URLs are returned unchanged.
 */
export const appendCacheBuster = (
  url: string,
  version: string | number = Date.now()
): string => {
  if (!url) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set('v', String(version));
    return parsedUrl.toString();
  } catch {
    return url;
  }
};
